import styled from 'styled-components'

export const PatientSharedMaterialsHeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-bottom: ${({theme}) => theme.spacing.lg};
`
